module.exports = __webpack_public_path__ + "img/icon_quick.0884bb1.png";